import React, { useMemo } from 'react';
import styles from './index.module.less';

const BodyContent = ({ body }: { body?: string }) => {
  const getIntroductionContent = useMemo(() => {
    return <>{body && <div className={styles.content} dangerouslySetInnerHTML={{ __html: body }} />}</>;
  }, [body]);

  return <>{getIntroductionContent}</>;
};

export default BodyContent;
